import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { TranslateLoader } from '@ngx-translate/core';
import { getWindow } from '@vendor/window/window';
import { Observable, of } from 'rxjs';

export class TranslateSessionLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private prefix?: string,
        private suffix?: string
    ) {}

    /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
    getTranslation(lang: string): any {
        const window: any = getWindow();
        const translations = window.IHD && window.IHD.translations;

        // Import shared translations between v1 and v2 if defined.
        let res: Observable<any>;
        if (translations && translations.hasOwnProperty(lang)) {
            res = of(translations[lang]);
        } else {
            let translationsURL = environment.assets.localeUrl.replace(
                ':locale',
                lang
            );

            // Note: use this to test multiple language key replacements
            // let translationsURL = 'assets/temp/language.json';

            const headers: HttpHeaders = new HttpHeaders().set(
                'Accept',
                'application/json'
            );
            res = this.http.get(translationsURL, { headers });
        }

        return res;
    }
}

/**
 * AoT requires an exported function for factories
 * @param http
 * @returns {TranslateSessionLoader}
 * @constructor
 */
export function TranslateLoaderFactory(http: HttpClient) {
    return new TranslateSessionLoader(http);
}
